/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ptBR, enUS } from 'date-fns/locale';

import Spinner from '../../shared/atoms/Spinner';
import * as S from './style';
import AssetIcon from '../../shared/atoms/AssetIcon';
import { useLocationsCacheContext } from '../../../context/LocationsCacheContext';
import { findItemWithId } from '../../../pages/Facilities/utils';

const Notification = ({ notification, onDismiss, dismissing }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { sensors } = useLocationsCacheContext();
  const { i18n } = useTranslation();

  const formatDate = date => {
    if (!date) return null;

    return formatDistanceToNow(new Date(date), {
      addSuffix: true,
      locale: i18n.language === 'en-US' ? enUS : ptBR,
    });
  };

  const getActionByEvent = () => {
    const sensor = findItemWithId(sensors, notification.sensor_id);
    history.push(
      `/portal/maps/facilities/${sensor.asset}/sensors/${sensor.id}`,
    );
  };

  const overlayDiv = (
    <S.OverlayCombo>
      <S.Spinner>
        <Spinner />
      </S.Spinner>
      <S.OvlMessage>
        {t('components.notification_container.dismissing')}
      </S.OvlMessage>
    </S.OverlayCombo>
  );

  return (
    <S.Notification
      role="alert"
      className="no"
      onClick={() => getActionByEvent()}
    >
      <AssetIcon status={notification.status} />
      <S.InfoCombo $attrDeleting={dismissing} className={`info `}>
        <S.SingleDismiss className="single-dismiss">
          <IconButton sx={{ padding: 0 }} size="small" onClick={onDismiss}>
            <Close fontSize="small" sx={{ color: 'white' }} />
          </IconButton>
        </S.SingleDismiss>
        <S.Title $notificationType={notification.status.toLowerCase()}>
          {notification.sensor_name}
        </S.Title>
        <S.Message>{notification.message}</S.Message>
        <S.Time>{formatDate(notification.created_at)}</S.Time>
      </S.InfoCombo>
      {dismissing && overlayDiv}
    </S.Notification>
  );
};

Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  onDismiss: PropTypes.func.isRequired,
  dismissing: PropTypes.bool.isRequired,
};

export default Notification;
